<template>
  <el-drawer
    size="60%"
    title="优惠券详情"
    :withHeader="false"
    :visible.sync="detailVisible"
    @close="closeDrawer">
    <section class="drawer-box" v-if="dataInfo">
      <div class="title-box row align-center space-between">
        <span>优惠券详情</span>
        <i class="el-icon-close" @click="closeDrawer"></i>
      </div>
      <div class="card">
        <div class="card-title row align-center">
          <i></i>
          <span>优惠券信息</span>
        </div>
        <div class="row align-center info-row">
          <div class="row align-center row-item">
            <span>优惠券类型：</span>
            <div>{{dataInfo.couponTypeName}}</div>
          </div>
          <div class="row align-center row-item">
            <span>优惠券来源：</span>
            <div>{{dataInfo.channelName}}</div>
          </div>
          <div class="row align-center row-item">
            <span>优惠金额：</span>
            <div style="color: #F8475F;">{{dataInfo.actualDiscountAmount}}</div>
          </div>
        </div>
        <div class="row align-center info-row">
          <div class="row align-center row-item" style="flex: 2;">
            <span>优惠券名称：</span>
            <div>{{dataInfo.name}}</div>
          </div>
          <div class="row align-center row-item">
            <span>核销时间：</span>
            <div>{{dataInfo.verifyTime}}</div>
          </div>
        </div>
        <div class="row align-center info-row" v-if="[0, 3].includes(dataInfo.couponType)">
          <div class="row align-center row-item" style="flex: 2;">
            <span>整单最低件数：</span>
            <div>{{dataInfo.countLimit}}</div>
          </div>
        </div>
        <div class="row align-center info-row" v-if="dataInfo.couponType === 1">
          <div class="row align-center row-item">
            <span>吊牌价面额：</span>
            <div>{{dataInfo.tagPriceAmount}}</div>
          </div>
        </div>
        <div class="row align-center info-row">
          <div class="row row-item">
            <span>优惠券说明：</span>
            <div style="white-space: pre-line;flex: 1;">{{dataInfo.remark}}</div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-title row align-center">
          <i></i>
          <span>优惠券货品</span>
        </div>
        <el-table
          border
          :data="goodsList"
          :cell-style="{ padding: '10px 0' }"
          :header-cell-style="{ background: '#FAFAFA', color: '#436481' }">
          <el-table-column prop="goodsNo" label="货号">
            <template slot-scope="scope">
              <div style="color:#1890ff;cursor:pointer;" @click="previewImage(scope.row.imageList)">{{scope.row.goodsNo}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="goodsName" label="货品名称"></el-table-column>
          <el-table-column prop="number" label="数量"></el-table-column>
          <template v-if="dataInfo.couponType === 1">
            <el-table-column prop="tagPrice" label="吊牌价"></el-table-column>
          </template>
          <template v-else>
            <el-table-column prop="couponAmount" label="单件优惠抵扣"></el-table-column>
          </template>
          <el-table-column prop="realPrice" label="实卖价"></el-table-column>
          <el-table-column prop="source" label="颜色/尺码">
            <template slot-scope="scope">
              <span v-for="(attr, a) in scope.row.attr.slice(0, 2)">{{attr.value}}<i v-if="a===0">，</i></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="card" v-if="giveList.length">
        <div class="card-title row align-center">
          <i></i>
          <span>赠品</span>
        </div>
        <el-table
          border
          :data="giveList"
          :cell-style="{ padding: '10px 0' }"
          :header-cell-style="{ background: '#FAFAFA', color: '#436481' }">
          <el-table-column prop="goodsNo" label="货号">
            <template slot-scope="scope">
              <div style="color:#1890ff;cursor:pointer;" @click="previewImage(scope.row.imageList)">{{scope.row.goodsNo}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="goodsName" label="货品名称"></el-table-column>
          <el-table-column prop="number" label="数量"></el-table-column>
          <el-table-column prop="source" label="颜色/尺码">
            <template slot-scope="scope">
              <span v-for="(attr, a) in scope.row.attr.slice(0, 2)">{{attr.value}}<i v-if="a===0">，</i></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </section>
    <el-image-viewer v-if="showViewer" :zIndex="9999" :url-list="imageList" :on-close="closeViewer"></el-image-viewer>
  </el-drawer>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer"
export default {
  props: {
    dataInfo: {
      type: Object,
      default: () => null
    }
  },
  components: {
    ElImageViewer
  },
  data(){
    return{
      detailVisible: true,
      imageList: [],
      showViewer: false,
      goodsList: [],
      giveList: []
    }
  },
  created() {
    if(this.dataInfo){
      this.goodsList = this.dataInfo.couponGoodsInfoList.filter(item => {
        return item.operationType !== '2'
      })
      this.giveList = this.dataInfo.couponGoodsInfoList.filter(item => {
        return item.operationType === '2'
      })
    }
  },
  methods: {
    closeDrawer(){
      this.detailVisible = false
      this.$emit('close')
    },
    previewImage(list){
      if(!list || (list && !list[0])) return this.$message.error("该货号没有货品图片")
      this.imageList = list
      this.showViewer = true
    },
    closeViewer() {
      this.showViewer = false
    }
  }
}
</script>

<style lang="scss" scoped>
.drawer-box{
  .title-box{
    padding: 20px;
    border-bottom: 1px solid #eee;
    span{
      font-size: 20px;
      font-weight: bold;
    }
    i{
      cursor: pointer;
      font-size: 20px;
    }
  }
  .card{
    margin: 20px;
    .card-title{
      margin-bottom: 10px;
      i{
        width: 4px;
        height: 18px;
        margin-right: 10px;
        background: #067cf2;
      }
      span{
        color: #000;
        font-size: 16px;
      }
    }
    .info-row{
      margin-top: 20px;
      .row-item{
        flex: 1;
        font-size: 15px;
        span{
          color: #666;
          width: 110px;
        }
      }
    }
  }
}
</style>